import React from "react";

import { paymentStatuses } from "../../../constants/paymentStatuses";
import "./PaymentStatusLabel.sass";
import { Tooltip } from "../../UI/Tooltip/Tooltip";

export const PaymentStatusLabel = ({ paymentStatusValue, description }) => {
  const paymentStatus = paymentStatuses.find(
    (paymentStatus) => paymentStatus.value === paymentStatusValue
  );

  const className = `PaymentStatusLabel PaymentStatusLabel__${paymentStatus.label}`;

  return (
    <Tooltip className={className} description={description}>
      <span className="PaymentStatusLabel__Text">{paymentStatus.label}</span>
    </Tooltip>
  );
};
